import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ProblemDetails } from "../_models/problem-details";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isRedirecting = false;

  intercept(
    req: import("@angular/common/http").HttpRequest<any>,
    next: import("@angular/common/http").HttpHandler,
  ): import("rxjs").Observable<import("@angular/common/http").HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === 401) {
          this.handleUnauthorized();
          return throwError("Your session has expired. Please log in again.");
        }
        if (error.status === 0) {
          return throwError(
            "The application has encountered service unavailable.",
          );
        }
        if (error instanceof HttpErrorResponse) {
          const problem = error.error as ProblemDetails;
          if (problem && problem.title) {
            if (problem.errors && typeof problem.errors === "object") {
              const flat = Object.values(problem.errors).flat().join("\n");
              return throwError(flat || problem.detail || problem.title);
            }
            return throwError(problem.detail || problem.title);
          }
          const applicationError = error.headers.get("Application-Error");
          if (applicationError) {
            return throwError(applicationError);
          }
          const serverError = error.error;
          let modelStateError = "";
          if (serverError.errors && typeof serverError.errors === "object") {
            for (const key in serverError.errors) {
              if (serverError.errors[key]) {
                modelStateError += serverError.errors[key] + "\n";
              }
            }
          }
          return throwError(modelStateError || serverError || "Server Error");
        }
      }),
    );
  }

  private handleUnauthorized(): void {
    const token = localStorage.getItem("token");
    if (!token || this.isRedirecting) {
      return;
    }
    this.isRedirecting = true;

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("selectedModuleId");
    localStorage.removeItem("selectedClientId");
    localStorage.removeItem("selectedClientName");
    localStorage.removeItem("selectedRoleId");

    const currentPath = window.location.pathname;
    if (currentPath !== "/auth/login" && currentPath !== "/login") {
      window.location.href = "/auth/login";
    } else {
      this.isRedirecting = false;
    }
  }
}
export const ErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
};
